import { Select, Text } from "@mantine/core";
import type { JSX } from "react";

interface DispositionInputProps {
    dispositions: string[];
    onChange?: (option: string | null) => void;
}

export function DispositionInput({ dispositions, onChange }: DispositionInputProps): JSX.Element | null {
    return (
        <Select
            label={
                <Text size="sm" pb="xs">
                    Resolution
                </Text>
            }
            placeholder="Choose an option"
            data={dispositions}
            variant="filled"
            pb="md"
            searchable
            styles={{ dropdown: { zIndex: 1000 } }}
            onChange={(value, _option) => {
                onChange?.(value);
            }}
            clearable
        />
    );
}
